import styled from "styled-components";

export const Wrapper = styled.div`

    display: flex;
    height: 180px;
    flex-direction: column;
    

`